import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-posh-shows';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Posh Shows: Your New Avenue to Showcase Your Items</title>
        <meta
          name='description'
          content='What is a Posh Show? How can you host Posh Shows? Find out how you can connect with the Poshmark community through live selling with this new feature.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-posh-shows' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-posh-shows' />
        <meta property='og:title' content='Poshmark Posh Shows: Your New Avenue to Showcase Your Items' />
        <meta
          property='og:description'
          content='What is a Posh Show? How can you host Posh Shows? Find out how you can connect with the Poshmark community through live selling with this new feature.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-10-20T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-10-20T00:00:00-00:00' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
